import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ChamadoEmpresaListarComponent } from './chamado-empresa-listar.component';
import { ChamadoEmpresaListarRoutingModule } from './chamado-empresa-listar-routing.module';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    ChamadoEmpresaListarComponent
  ],
  imports: [
    CommonModule,
    ChamadoEmpresaListarRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    MessagesModule,
    InputTextModule,
    TooltipModule,
    DropdownModule
  ]
})
export class ChatSuporteEmpresaListarModule { }
